import { render, staticRenderFns } from "./CPLoginAsToolbar.vue?vue&type=template&id=c67b33a8&scoped=true&"
import script from "./CPLoginAsToolbar.vue?vue&type=script&lang=ts&"
export * from "./CPLoginAsToolbar.vue?vue&type=script&lang=ts&"
import style0 from "./CPLoginAsToolbar.vue?vue&type=style&index=0&id=c67b33a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67b33a8",
  null
  
)

export default component.exports